import AvatarDefault from '../../../../assets/medium_default_optimized.png';
import VerifiedIcon from '../../../../assets/verified-icon.svg';
import FoundingCreatorIcon from '../../../../assets/founding_creator_icon.png';
import { formatNumber, handleUserClick } from '../../../../utils/helper.util';
import Button from '../../../Button';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { profileAtom } from '../../../Settings/atom';
import RankBadge from '../../../RankBadge';
import useRankBadgeTooltip from '../../../../hooks/useRankBadgeTooltip';
import { WriterBadgeInfo } from '../../../WriterBadgeInfo';
import { UnauthorizedDispatcher } from 'src/utils/unauthorized-dispatcher';

const CardAuthor = (props) => {
  const { author, isHiddenRankBadge, isHiddenInfo, handleFollowUser, isSmallText, isLoading } =
    props;
  const [profile] = useAtom(profileAtom);
  const {
    openPopup,
    totalAwardedPoints,
    isTouchDevice,
    handleMouseEnter,
    handleClick,
    handleMouseLeave
  } = useRankBadgeTooltip();
  const navigate = useNavigate();
  const userId = JSON.parse(localStorage.getItem('user'))?.id;

  return (
    <div className={`flex items-start @container ${isSmallText ? 'gap-1' : 'gap-2'}`}>
      <img
        className={`w-[40px] h-[40px] @md:w-[64px] @md:h-[64px] rounded-full object-cover cursor-pointer flex-shrink-0 ${isSmallText ? '' : 'md:w-[56px] md:h-[56px]'}`}
        src={author?.imgUrl || AvatarDefault}
        onClick={(e) =>
          handleUserClick(e, () => {
            navigate(`/${author?.username}`);
          })
        }
        alt=""
      />
      <div className={`flex flex-col gap-1 flex-1 min-w-0 ${isSmallText ? '' : 'md:gap-2'}`}>
        <div className="flex items-center gap-2 @md:gap-4 w-full">
          <div
            className="flex flex-wrap items-center gap-2 max-w-[160px] md:max-w-full cursor-pointer flex-1"
            onClick={(e) =>
              handleUserClick(e, () => {
                navigate(`/${author?.username}`);
              })
            }
          >
            <div className="flex flex-wrap gap-1 items-center min-w-0">
              <p
                className={`font-[600] truncate ${isSmallText ? 'text-xs' : 'text-sm xl:text-lg lg:font-[800] truncate'} hover:text-growth-green-500 transition duration-200`}
                title={author?.firstName ? author?.firstName : 'Anonymous'}
              >
                {author?.firstName ? author?.firstName : 'Anonymous'}
              </p>
              {author?.isVerifiedAuthor && <img src={VerifiedIcon} alt="" />}
              {author?.isFoundingCreator && (
                <img
                  src={FoundingCreatorIcon}
                  className="w-4 h-4"
                  alt="Founding Creator"
                  title="Founding Creator"
                />
              )}
              {author?.username && (
                <span
                  className={`font-[600] ${isSmallText ? 'text-xs' : 'text-sm'} @md:text-base text-02-dim-gray`}
                >
                  @{author?.username}
                </span>
              )}
            </div>
            {!isHiddenRankBadge && (
              <div
                className="relative"
                onMouseEnter={() => !isTouchDevice && handleMouseEnter(author?.id)}
                onClick={(e) => {
                  e.stopPropagation();
                  handleClick(author?.id);
                }}
                onMouseLeave={() => !isTouchDevice && handleMouseLeave()}
              >
                <RankBadge rank={author?.currentRank} />
                {openPopup && (
                  <div className="absolute top-[34px] md:top-[-20px] left-[-50%] md:left-[110px] z-10">
                    <WriterBadgeInfo
                      rank={author?.currentRank}
                      totalReceivedPoint={totalAwardedPoints.totalReceivedPoint}
                      totalReceivedUsers={totalAwardedPoints.totalReceivedUsers}
                    />
                  </div>
                )}
              </div>
            )}
            {author?.id === profile.id && (
              <div className="px-2 py-1 rounded-[80px] bg-growth-green-50 text-xs text-growth-green-900 font-[600]">
                You
              </div>
            )}
          </div>
        </div>
        <div
          className={`flex items-center flex-wrap gap-2 md:gap-[40px] ${isHiddenInfo ? 'hidden' : ''}`}
        >
          <p className="text-sm md:text-base font-[800]">
            {formatNumber(author?.followerNumber)}{' '}
            <span className="font-[400]">
              {author?.followerNumber === 1 ? 'follower' : 'followers'}
            </span>
          </p>
          <p className="text-sm md:text-base font-[800]">
            {formatNumber(author?.followingNumber)} <span className="font-[400]">following</span>
          </p>
          <p className="text-sm md:text-base font-[800]">
            {formatNumber(author?.contributionNumber)}{' '}
            <span className="font-[400]">
              {author?.contributionNumber === 1 ? 'article' : 'articles'}
            </span>
          </p>
        </div>
        <p
          title={author?.description}
          className={`italic ${isSmallText ? 'text-xs' : 'text-sm'} line-clamp-2 w-full`}
        >
          {author?.description || 'No description'}
        </p>
      </div>
      {profile.id !== author.id && (
        <Button
          className={`min-w-[85px] px-[10px] self-start py-[6px] text-xs !font-[700] flex-shrink-0 ${isSmallText ? '' : 'md:min-w-[100px] md:px-[14px] md:py-[8px] md:text-sm'}`}
          variant="primary"
          onClick={() => {
            if (!userId) return UnauthorizedDispatcher();
            handleFollowUser(author.id, author.isFollowing);
          }}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {author?.isFollowing ? 'Following' : 'Follow'}
        </Button>
      )}
    </div>
  );
};

export default CardAuthor;
